var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "tabs-demo__size" },
        [
          _c(
            "v-col",
            { attrs: { span: 22 } },
            [
              _c(
                "v-tabs",
                {
                  attrs: { size: "S", name: "tabs-s-card", type: "button" },
                  model: {
                    value: _vm.activeNamebutton,
                    callback: function ($$v) {
                      _vm.activeNamebutton = $$v
                    },
                    expression: "activeNamebutton",
                  },
                },
                [
                  _c(
                    "v-tab-pane",
                    { attrs: { label: "基础通信 Topic", value: "1" } },
                    [_c("Base", { attrs: { productKey: _vm.productKey } })],
                    1
                  ),
                  _c(
                    "v-tab-pane",
                    { attrs: { label: "物模型通信 Topic", value: "2" } },
                    [
                      _c("Physicalmodel", {
                        attrs: { productKey: _vm.productKey },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-tab-pane",
                    { attrs: { label: "自定义 Topic", value: "3" } },
                    [
                      _c("Diy", {
                        attrs: {
                          productKey: _vm.productKey,
                          productId: _vm.productId,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }